import { OcrResult } from "@finway-group/shared/lib/models"
import i18n from "Shared/locales/i18n"

export const getSenderCountryCode = (data: OcrResult): string => {
    const countryCodeTokens = data.eInvoiceData?.sender?.senderAddress?.country_code?.split("_") || []
    return countryCodeTokens[countryCodeTokens.length - 1] || ""
}

export const getReceiverCountryCode = (data: OcrResult): string => {
    const countryCodeTokens = data.eInvoiceData?.receiver?.receiverAddress?.country_code?.split("_") || []
    return countryCodeTokens[countryCodeTokens.length - 1] || ""
}

export const formatAddress = (addressData: any, countryCode: string): string => {
    if (!addressData) {
        return ""
    }
    return `${addressData.street_name || ""}, ${addressData.postal_zone || ""} ${addressData.city_name || ""}, ${countryCode}`
}

export const getInvoiceTypeLabel = (invoiceTypeCode: number) => {
    switch (invoiceTypeCode) {
        case 71:
            return i18n.t("label:e_invoice_type.request_for_payment")
        case 80:
            return i18n.t("label:e_invoice_type.debit_note_goods_services")
        case 82:
            return i18n.t("label:e_invoice_type.metered_services_invoice")
        case 84:
            return i18n.t("label:e_invoice_type.debit_note_financial_adjustments")
        case 102:
            return i18n.t("label:e_invoice_type.tax_notification")
        case 218:
            return i18n.t("label:e_invoice_type.final_payment_request")
        case 219:
            return i18n.t("label:e_invoice_type.payment_request_completed_units")
        case 331:
            return i18n.t("label:e_invoice_type.commercial_invoice_with_packing")
        case 348:
            return i18n.t("label:e_invoice_type.corrected_invoice")
        case 380:
            return i18n.t("label:e_invoice_type.commercial_invoice")
        case 382:
            return i18n.t("label:e_invoice_type.commission_note")
        case 383:
            return i18n.t("label:e_invoice_type.debit_note")
        case 386:
            return i18n.t("label:e_invoice_type.prepayment_invoice")
        case 388:
            return i18n.t("label:e_invoice_type.tax_invoice")
        case 393:
            return i18n.t("label:e_invoice_type.factored_invoice")
        case 395:
            return i18n.t("label:e_invoice_type.consignment_invoice")
        case 553:
            return i18n.t("label:e_invoice_type.forwarders_invoice_discrepancy")
        case 575:
            return i18n.t("label:e_invoice_type.insurance")
        case 623:
            return i18n.t("label:e_invoice_type.forwarders_invoice")
        case 780:
            return i18n.t("label:e_invoice_type.freight_invoice")
        case 817:
            return i18n.t("label:e_invoice_type.claim_notification")
        case 870:
            return i18n.t("label:e_invoice_type.consular_invoice")
        case 875:
            return i18n.t("label:e_invoice_type.partial_construction_invoice")
        case 876:
            return i18n.t("label:e_invoice_type.partial_final_construction_invoice")
        case 877:
            return i18n.t("label:e_invoice_type.final_construction_invoice")
        default:
            return i18n.t("label:e_invoice_type.invoice")
    }
}
